<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title fw-bold" id="addRuleModalLabel">Block Rule</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="modal-body">
      <div class="mb-3">
        <label for="name-input" class="form-label small fw-bold">Rule Title</label>
        <input formControlName="name" type="text" class="form-control" id="name-input" placeholder="Enter rule title">
      </div>

      <div class="mb-3">
        <label for="subid-input" class="form-label small fw-bold">Filter Condition</label>
        <input formControlName="subid" type="text" class="form-control" id="subid-input" placeholder="Enter SubID">
      </div>

      <div class="mb-3">
        <label class="form-label">Action</label>
        <div>
          <div class="form-check">
            <input formControlName="blockTraffic" class="form-check-input" type="radio" id="block-traffic-true" [value]="true">
            <label class="form-check-label small fw-bold" for="block-traffic-true">Block traffic</label>
          </div>
          <div class="form-check">
            <input formControlName="blockTraffic" class="form-check-input" type="radio" id="block-traffic-false" [value]="false">
            <label class="form-check-label small fw-bold" for="block-traffic-false">Redirect traffic to</label>
          </div>

          @if (!form.value?.blockTraffic) {
            <input formControlName="redirectUrl" type="text" class="form-control mt-2" placeholder="Enter redirect URL">
          }
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>

      <button [disabled]="invalid()" type="submit" class="btn btn-primary fw-bold">
        {{ blockRule ? 'Update' : 'Create' }}
      </button>
    </div>
  </form>
</div>
